import React from 'react';
import {
    Box,
    Button,
    Link,
    Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <>
            <Typography variant="h6" className='login_typography_content'>
                Sorry, this page isn't available.
            </Typography>
            <Typography variant="h6" className='login_typography_content'>
                The link you followed may be broken, or the page may have been removed.
            </Typography>
            <Typography variant="h6" className='login_typography_content'>
                <Link
                    href=""
                    className='primaryBlueColor'
                    underline="none"
                    onClick={() => navigate("/")}
                >
                    Go back to the website
                </Link>
            </Typography>
        </>
    );
};

export default NotFound;
